import { Hidden } from '@material-ui/core';
import React from 'react';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import LaunchIcon from '@material-ui/icons/Launch';
import { useSelector } from 'react-redux';
import { Redirect, useRouteMatch } from 'react-router';
import { GuidedProcessSupportBlock } from '../../../../../global/components/guided-process-support-block';
import { MainContent } from '../../../../../global/components/layout/main-content-container';
import { PageContainer } from '../../../../../global/components/layout/page-container';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { SideBarContent } from '../../../../../global/components/layout/sidebar-content';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { ArcRoutes } from '../../../constants/routes';
import { GuidedProcessSupportProps } from '../../../models/arc-epi-props';
import { GroupsState } from '../../groups/groups-model';
import { useGroupsBillingSettings } from '../../../hooks/useGroupsBillingSettings';
import { ExternalLinks } from '../../../../../global/models/lov-proc-model';
import { ExternalLink } from '../../../../../global/components/external-link-modal';
import { buttonStyles } from '../../../../../global/constants/theme/styles/components/buttonstyles';
import { ApiEndpoint } from '../../../../../global/constants/api-endpoints';
import { DomoLink } from '../../../../../global/components/domo-report-link';

interface Props {
    groupsBillingSettingsId: string;     
}

const ReportsBenefitsGroup : React.FC<Props> = (props: Props) => {
    const buttonClasses = buttonStyles();
    const routeMatch = useRouteMatch();
    const groupsState = useSelector<TcsmStates, GroupsState>(state => state.groupsState);
    const groupSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.GroupsLanding}${ArcRoutes.GroupSearch}`);    
    const externalLinks = useSelector<TcsmStates, ExternalLinks>(state => state.lovProcState.externalLinks);    
    // Select a group if none has been selected.
    if (!groupsState?.currentGroup?.group_id) {
        return (
            <Redirect to={{
                pathname: groupSelect,
                state: {
                    actionLink: routeMatch.path,
                },
            }} />);
        }
        
    const useGroupsBillingSettingsLoaded = useGroupsBillingSettings(props.groupsBillingSettingsId);    
    const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const groupsProps = epiProps?.groupsBillingSettingsState?.epiContent;
    const gpsSettings = useSelector<TcsmStates, GuidedProcessSupportProps>(state => state.epiProps?.gpsSettingsState?.epiContent);   

    if (!useGroupsBillingSettingsLoaded) {
        return <LoadingCircle />;
    }

    function CompleteReportItemLink(linkUrl: string): string{
        return linkUrl.replace('=:group', `=${groupsState?.currentGroup?.group_id}`);
    }

    function RenderReportItem(linkText: string, linkUrl: string){

        if (!linkUrl) return null;

        if (linkUrl.includes(ApiEndpoint.domoUrl)) {
            return <li><DomoLink domoLink={linkUrl} linkText={linkText} /></li>;
        }

        return (
            <>
            <li><ExternalLink newWindow linkIcon={<LaunchIcon />} linkText={!linkText ? linkUrl : linkText } linkUrl={linkUrl} /></li>            
            </>
         );
    }

    function RenderContent(){

        if (!groupsState?.currentGroup?.group_id) return null;

        return (           
           <ul className={buttonClasses.linkButtonList} >
                {RenderReportItem(groupsProps.reportsBenefitsGroupViewChangeTitle, CompleteReportItemLink(externalLinks.change_report_page))}
                {RenderReportItem(groupsProps.reportsBenefitsGroupViewEnrollmentTitle, CompleteReportItemLink(`${ApiEndpoint.domoUrl}report_name=MLPSTCSMEnrollment&group_id=:group`))}
                {RenderReportItem(groupsProps.reportsBenefitsGroupViewAnnualEnrollmentTitle, CompleteReportItemLink(`${ApiEndpoint.domoUrl}report_name=MLPSTCSMAnnualEnrollment&group_id=:group`))}
                {RenderReportItem(groupsProps.institutionSubSelectReportTitle, CompleteReportItemLink(`${ApiEndpoint.domoUrl}report_name=MLPSInstitutionSubSelectReport&group_id=:group`))}
            </ul>           
        );
    }    

    return (
        <PageContainer>
            <MainContent>                
                <PageHeader headerText={groupsProps.reportsBenefitsGroupTitle} description={groupsProps.reportsBenefitsGroupDescription} />
                <Hidden mdUp>
					<SideBarContent>
                    <GuidedProcessSupportBlock title={gpsSettings?.benefitsGroupReportsGpsTitle} contents={gpsSettings?.benefitsGroupReportsGps} />
					</SideBarContent>
				</Hidden>
                <RenderContent/>
            </MainContent>
            
            <Hidden smDown>
                <SideBarContent>
                    <GuidedProcessSupportBlock title={gpsSettings?.benefitsGroupReportsGpsTitle} contents={gpsSettings?.benefitsGroupReportsGps} />
                </SideBarContent>
            </Hidden>
        </PageContainer>
    );
};

export default ReportsBenefitsGroup;